import { AxiosError } from 'axios';

/** Axios / API JSON gövdesinden kullanıcıya gösterilecek mesajı çıkarır */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const ax = error as AxiosError<{ message?: string }>;
  const msg = ax.response?.data?.message;
  if (typeof msg === 'string' && msg.trim()) return msg.trim();
  return fallback;
}
